(() => {
  const popup = document.querySelector('[data-hydros-promo]');
  const version = popup?.dataset.version || 'hydros-club-v1';
  const keys = { dismissed: `hydros:club:${version}:dismissed`, subscribed: `hydros:club:${version}:subscribed` };
  const read = key => { try { return localStorage.getItem(key); } catch { return null; } };
  const write = (key, value) => { try { localStorage.setItem(key, value); } catch {} };
  const track = (action, source) => {
    const detail = { action, source, page: location.pathname };
    window.dispatchEvent(new CustomEvent('hydros:newsletter', { detail }));
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: `hydros_newsletter_${action}`, hydros_newsletter: detail });
    }
  };
  document.querySelectorAll('form.hydros-club__form, form[data-hydros-newsletter-form]').forEach(form => {
    form.addEventListener('submit', () => {
      if (!form.checkValidity()) return;
      track('submit', form.dataset.newsletterSource || 'club');
      form.setAttribute('aria-busy', 'true');
    });
  });
  document.querySelectorAll('[data-newsletter-result="success"]').forEach(result => {
    write(keys.subscribed, 'true');
    track('success', result.dataset.newsletterSource || 'footer');
  });
  if (!popup) return;
  const professionalPage = Boolean(document.querySelector('[data-hydros-pro]'));
  const excluded = (popup.dataset.excludedPaths || '').split(/[\n,]+/).map(path => path.trim()).filter(Boolean);
  const manualOnly = professionalPage || /^\/(policies|cart)(\/|$)/.test(location.pathname) || location.pathname.startsWith('/pages/contact') || excluded.some(path => location.pathname.startsWith(path));
  const dialog = popup.querySelector('[data-hydros-promo-dialog]');
  const invite = popup.querySelector('[data-hydros-promo-invite]');
  const launcher = popup.querySelector('[data-hydros-club-launcher]');
  if (!dialog || !invite) return;
  const mobile = matchMedia('(max-width: 749px)').matches;
  const days = Number(mobile ? popup.dataset.memoryDaysMobile : popup.dataset.memoryDays) || 14;
  const delay = Math.max(45000, Number(popup.dataset.delay) || 90000);
  const depth = Number(popup.dataset.scroll) || 30;
  const visitKey = `hydros:club:${version}:visit`;
  const readVisit = () => { try { return JSON.parse(sessionStorage.getItem(visitKey) || '{}'); } catch { return null; } };
  const storedTime = visit => Number.isFinite(visit?.activeMs) ? Math.min(delay, Math.max(0, visit.activeMs)) : 0;
  const visit = readVisit();
  let activeMs = storedTime(visit);
  let seenThisVisit = visit?.shown === true;
  let activeSince = document.hidden ? null : performance.now();
  const elapsed = () => Math.min(delay, activeMs + (activeSince === null ? 0 : performance.now() - activeSince));
  const saveVisit = () => {
    try { sessionStorage.setItem(visitKey, JSON.stringify({ activeMs: elapsed(), shown: seenThisVisit })); } catch {}
  };
  const pauseClock = () => { activeMs = elapsed(); activeSince = null; saveVisit(); };
  const resumeClock = () => {
    const latest = readVisit();
    activeMs = Math.max(activeMs, storedTime(latest));
    seenThisVisit = seenThisVisit || latest?.shown === true;
    if (activeSince === null && !document.hidden) activeSince = performance.now();
  };
  let opened = false;
  let dismissed = false;
  let trigger = null;
  let timer;
  let frame;
  const recentlyDismissed = () => Date.now() - Number(read(keys.dismissed) || 0) < days * 86400000;
  const visible = element => {
    const style = getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.visibility !== 'hidden' && style.visibility !== 'collapse' && style.display !== 'none' && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth;
  };
  const busy = () => document.hidden || Boolean(document.querySelector('cart-drawer.active')) || [...document.querySelectorAll('[role="alertdialog"], [role="dialog"]:not(.hydros-club__dialog), dialog[open]:not(.hydros-club__dialog)')].some(visible) || document.activeElement?.matches('input, textarea, select');
  const eligible = () => {
    const height = document.documentElement.scrollHeight - innerHeight;
    return height > 0 && scrollY / height * 100 >= depth && elapsed() >= delay;
  };
  const concealInvite = () => { invite.hidden = true; };
  const concealLauncher = () => { if (launcher) launcher.hidden = true; };
  const stop = () => {
    clearTimeout(timer);
    cancelAnimationFrame(frame);
    removeEventListener('scroll', onScroll);
    removeEventListener('resize', onScroll);
    document.removeEventListener('visibilitychange', onVisibility);
  };
  const consider = () => {
    clearTimeout(timer);
    if (manualOnly || document.hidden) { concealInvite(); concealLauncher(); return; }
    const immersive = [...document.querySelectorAll('hydros-product-journey, hydros-filter-journey, [data-home-story]')].some(visible);
    if (immersive) { concealInvite(); concealLauncher(); return; }
    if (dialog.open) { concealInvite(); concealLauncher(); return; }
    if (busy()) { concealInvite(); concealLauncher(); clearTimeout(timer); timer = setTimeout(consider, 2000); return; }
    if (launcher) launcher.hidden = false;
    if (opened || seenThisVisit || dismissed || recentlyDismissed() || read(keys.subscribed) === 'true' || popup.dataset.subscribed === 'true' || popup.dataset.teaserEnabled !== 'true' || (mobile && popup.dataset.teaserMobile !== 'true')) {
      concealInvite();
      return;
    }
    const remaining = delay - elapsed();
    if (remaining > 0) { timer = setTimeout(consider, remaining); return; }
    if (!eligible()) return;
    show('automatic');
  };
  const onScroll = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(consider); };
  const onVisibility = () => {
    if (document.hidden) pauseClock();
    else resumeClock();
    consider();
  };
  const dismiss = ({ remember = true, restore = true } = {}) => {
    if (remember) { dismissed = true; write(keys.dismissed, String(Date.now())); }
    concealInvite();
    const wasOpen = dialog.open;
    if (wasOpen) dialog.close();
    if (restore && wasOpen && trigger?.isConnected) trigger.focus({ preventScroll: true });
    consider();
  };
  const show = source => {
    concealInvite();
    concealLauncher();
    clearTimeout(timer);
    opened = true;
    seenThisVisit = true;
    saveVisit();
    trigger = document.activeElement;
    if (!dialog.open) dialog.show();
    dialog.focus({ preventScroll: true });
    track('view', source);
  };
  popup.hidden = false;
  document.addEventListener('click', event => {
    if (event.target.closest('[data-hydros-club-open], [data-hydros-promo-teaser]')) { event.preventDefault(); show('voluntary'); }
    else if (event.target.closest('[data-hydros-promo-close], [data-hydros-promo-invite-close]')) { dismiss(); track('close', 'club'); }
    else if (dialog.open && !dialog.contains(event.target)) dismiss({ restore: false });
  });
  popup.querySelector('[data-hydros-promo-copy]')?.addEventListener('click', async event => {
    const button = event.currentTarget;
    const feedback = popup.querySelector('[data-hydros-code-feedback]');
    const code = popup.querySelector('[data-hydros-promo-code]')?.textContent.trim();
    if (!code || !feedback) return;
    try {
      await navigator.clipboard.writeText(code);
      feedback.textContent = button.dataset.copied;
      track('code_copy', 'club');
    } catch {
      feedback.textContent = button.dataset.copyError;
    }
    feedback.hidden = false;
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && (dialog.open || !invite.hidden)) { event.preventDefault(); dismiss(); }
  });
  document.addEventListener('focusin', () => { if (!dialog.open) consider(); });
  const observer = new MutationObserver(() => {
    if (document.querySelector('cart-drawer.active')) dismiss({ remember: false, restore: false });
    else consider();
  });
  const drawer = document.querySelector('cart-drawer');
  const start = () => {
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('visibilitychange', onVisibility);
    if (drawer) observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    consider();
  };
  addEventListener('pagehide', () => { pauseClock(); stop(); observer.disconnect(); });
  addEventListener('pageshow', event => {
    document.querySelectorAll('form[aria-busy="true"]').forEach(form => form.removeAttribute('aria-busy'));
    if (event.persisted) { resumeClock(); start(); }
  });
  const result = popup.querySelector('[data-newsletter-result]');
  if (result || new URLSearchParams(location.search).get('hydros_club') === 'preview') show('return');
  start();
})();
